import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Collapse} from 'reactstrap';
import './promoVideo.css';
import PromoVideoFolderList from "./PromoVideoFolderList";
import PromoVideoUrlList from "./PromoVideoUrlList";

class PromoVideoFolder extends Component {

    toggle = () => {
        const {folder, onOpenFoldersChange} = this.props;
        onOpenFoldersChange(folder.id);
    };

    getCollapsedContent = () => {
        const {folder} = this.props;
        if (folder.parentFolderId === null) {
            return (
                <PromoVideoFolderList
                    folders={folder.subFolders}
                    parentFolderId={folder.id}
                    addFolder={this.props.addFolder}
                    renameFolder={this.props.renameFolder}
                    deleteFolder={this.props.deleteFolder}
                    addUrl={this.props.addUrl}
                    changeUrlValue={this.props.changeUrlValue}
                    deleteUrl={this.props.deleteUrl}
                    onOpenFoldersChange={this.props.onOpenFoldersChange}
                    openFolderIds={this.props.openFolderIds}
                />
            );
        } else {
            return (
                <PromoVideoUrlList
                    urls={folder.videoUrls}
                    folderId={folder.id}
                    addUrl={this.props.addUrl}
                    changeUrlValue={this.props.changeUrlValue}
                    deleteUrl={this.props.deleteUrl}
                />
            );
        }
    }

    render() {
        const {folder, openFolderIds} = this.props;
        const isOpen = openFolderIds.some(id => id === folder.id);
        return (
            <section>
                <div className="promo_video_folder_row">
                    <div
                        className="promo_video_chevron_icon"
                        onClick={this.toggle}>
                        {
                            isOpen ?
                                <i className="fas fa-chevron-down icon"/> :
                                <i className="fas fa-chevron-right icon"/>
                        }
                    </div>
                    <h5 onClick={this.toggle}>{folder.name}</h5>
                    <Button
                        onClick={() => this.props.renameFolder(folder)}
                        size="sm"
                        round="true"
                        icon="true"
                        color="inverse"
                    >
                        <i className="fa fa-edit"/>
                    </Button>
                    <Button
                        onClick={event => {
                            event.stopPropagation();
                            this.props.deleteFolder(folder.id)
                        }}
                        color="danger"
                        size="sm"
                        round="true"
                        icon="true"
                        className="promo_video_button_left_margin"
                    >
                        <i className="fa fa-times"/>
                    </Button>
                </div>
                <Collapse
                    className="promo_video_collapse"
                    isOpen={isOpen}
                >
                    {this.getCollapsedContent()}
                </Collapse>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps)(PromoVideoFolder)



// WEBPACK FOOTER //
// ./src/components/PromoVideo/PromoVideoFolder.js